module.exports = __webpack_public_path__ + "assets/img/weixin-743830b6.png";